import React, { useEffect, useState } from "react";
import { useSetting } from "store/settings";
import { handleSuccessMessages } from "store/auth";
import { Field, Form, Formik } from "formik";
import {
  Loading,
  TextField,
  MultiSelect,
  Select,
  CheckBox,
} from "components/form";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { generate_uuid } from "lib/helpers";
import { required, validationWrapper, number } from "lib/formValidations";
import { TextArea } from "components/form";
import MultiselectAddNew from "components/MultiSelectAddNew";
const Widgets = (props) => {
  const {
    dispatch,
    getSetting,
    submitSetting,
    widgets,
    loading,
  } = useSetting();
  const key = "widgets";
  const [showAddWidget, setShowAddWidget] = useState(false);
  const [showEditWidget, setShowEditWidget] = useState(false);
  const [showDeleteWidget, setShowDeleteWidget] = useState(false);
  const [item, setItem] = useState("");
  const core = useCore();

  useEffect(() => {
    dispatch(getSetting(key));
    core.dispatch(core.getGenres());
    core.dispatch(core.getProductCategories());
  }, []);

  // if (loading) {
  //    return (<div className="box p-5 flex justify-center">
  //       <Loading/>
  //    </div>)
  // }

  return (
    <>
      <AddWidget
        show={showAddWidget}
        close={() => setShowAddWidget(false)}
        title="افزودن ویجت"
      />
      <EditWidget
        item={item}
        show={showEditWidget}
        close={() => setShowEditWidget(false)}
        title="ویرایش ویجت"
      />
      <DeleteWidget
        item={item}
        show={showDeleteWidget}
        close={() => setShowDeleteWidget(false)}
        title="حذف ویجت"
        submite={async () => {
          await dispatch(
            submitSetting({
              value: [...widgets.filter((i) => i.uuid !== item.uuid)],
              key,
            })
          );
          dispatch(getSetting(key));
          setShowDeleteWidget(false);
        }}
      />

      <div className="box intro-y col-span-12 overflow-auto lg:overflow-visible">
        <div className="flex justify-between py-2 px-3">
          <h3>لیست ویجت ها</h3>
          <button
            onClick={() => setShowAddWidget(true)}
            className="btn btn-sm btn-primary"
          >
            افزودن ویجت
          </button>
        </div>
        <hr />
        {widgets && widgets.length < 1 && (
          <h3 className="p-5 text-center">چیزی برای نمایش وجود ندارد!</h3>
        )}
        {widgets && widgets.length > 0 && (
          <table className="table table-report -mt-2">
            <thead>
              <tr>
                <th className="whitespace-nowrap text-center">اولویت</th>
                <th className="whitespace-nowrap text-center">عنوان</th>
                <th className="whitespace-nowrap text-center">عنوان انگلیسی</th>
                <th className="whitespace-nowrap text-center">دسته بندی ها</th>
                <th className="whitespace-nowrap text-center">ژانر ها</th>
                <th className="whitespace-nowrap text-center">وضعیت</th>
                <th className="whitespace-nowrap text-center">عملیات</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {widgets &&
                widgets.map((item) => (
                  <tr>
                    <td>{item.order}</td>
                    <td>{item.title}</td>
                    <td>{item.en_title}</td>
                    <td className="text-xs">
                      {item.categories &&
                        core.productCategories &&
                        core.productCategories
                          .filter((i) => item.categories.includes(i.value))
                          .map((gi) => gi.label + ", ")}
                    </td>
                    <td className="text-xs">
                      {item.genres &&
                        core.genres &&
                        core.genres
                          .filter((i) => item.genres.includes(i.value))
                          .map((gi) => gi.label + ", ")}
                    </td>
                    <td>{item.status ? "فعال" : "غیرفعال"}</td>
                    <td className="w-56">
                      <button
                        className="btn btn-sm btn-info mx-1"
                        onClick={() => {
                          setItem(item);
                          setShowEditWidget(true);
                        }}
                      >
                        ویرایش
                      </button>
                      <button
                        className="btn btn-sm btn-danger mx-1"
                        onClick={() => {
                          setItem(item);
                          setShowDeleteWidget(true);
                        }}
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};

export default Widgets;

export function AddWidget(props) {
  const { dispatch, getSetting, submitSetting, widgets } = useSetting();
  const core = useCore();
  const key = "widgets";
  useEffect(() => {
    dispatch(getSetting(key));
  }, []);
  return (
    <Modal show={props.show} handleClose={props.close} title={props.title}>
      <Formik
        initialValues={{ uuid: generate_uuid() }}
        onSubmit={async (values, { setSubmitting }) => {
          await dispatch(
            submitSetting({ value: [...widgets, values], key }, () => {
              handleSuccessMessages("ویرایش اطلاعات انجام شد");
              props.close();
            })
          );
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty, values }) => (
          <Form>
            <div className="box rounded p-3">
              <h3>تنظیمات ویجت ها</h3>
              <hr className="my-2" />
              <div className="">
                <div className="intro-x grid grid-cols-2 gap-4">
                  <Field
                    placeholder="انتخاب نوع"
                    label="انتخاب نوع :"
                    name="type"
                    component={Select}
                    options={[
                      { value: "PRODUCT_LIST", label: "محصولات" },
                      { value: "FEATURED_LIST", label: "محصولات ویژه" },
                      { value: "NEW_PRODUCT_LIST", label: "محصولات جدید" },
                      { value: "GENRE_LIST", label: "ژانرها" },
                      { value: "PRODUCT", label: "تک محصول" },
                    ]}
                  />
                  {values.type == "PRODUCT" && (
                    <Field
                      placeholder="شناسه محصول"
                      label="شناسه محصول :"
                      name="product_id"
                      type="number"
                      component={TextField}
                    />
                  )}
                  {(values.type == "NEW_PRODUCT_LIST" ||
                    values.type == "FEATURED_LIST") && (
                    <Field
                      placeholder="تعداد محصول"
                      label="تعداد محصول :"
                      name="count"
                      component={TextField}
                    />
                  )}
                  <Field
                    placeholder="عنوان"
                    label="عنوان :"
                    name="title"
                    component={TextField}
                  />
                  <Field
                    placeholder="عنوان انگلیسی"
                    label="عنوان انگلیسی :"
                    name="en_title"
                    component={TextField}
                  />
                  <Field
                    placeholder="اولویت"
                    label="اولویت :"
                    name="order"
                    component={TextField}
                    type="number"
                  />
                  <Field
                    placeholder="فعال"
                    label="فعال "
                    name="status"
                    component={CheckBox}
                  />
                  <Field
                    placeholder="نمایش تصادفی"
                    label="نمایش تصادفی "
                    name="random_sort"
                    component={CheckBox}
                  />
                  {values.type == "PRODUCT_LIST" && (
                    <>
                      <div>
                        <Field
                          placeholder="انتخاب دسته بندی"
                          label="انتخاب دسته بندی :"
                          name="categories"
                          component={MultiSelect}
                          valueOnly={true}
                          options={core.productCategories || {}}
                        />
                      </div>
                      <div>
                        <Field
                          placeholder="انتخاب ژانر"
                          label="انتخاب ژانر :"
                          name="genres"
                          valueOnly={true}
                          component={MultiSelect}
                          options={core.genres || {}}
                        />
                      </div>
                    </>
                  )}
                  <div></div>
                  <button
                    className="mt-4 btn btn-primary w-20"
                    type="submit"
                    disabled={!!(isSubmitting || !dirty)}
                  >
                    {isSubmitting ? <Loading /> : "ذخیره"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function EditWidget(props) {
  const { dispatch, getSetting, submitSetting, widgets } = useSetting();
  const core = useCore();
  const key = "widgets";
  useEffect(() => {
    dispatch(getSetting(key));
  }, []);
  return (
    <Modal show={props.show} handleClose={props.close} title={props.title}>
      <Formik
        initialValues={props.item}
        onSubmit={async (values, { setSubmitting }) => {
          await dispatch(
            submitSetting(
              {
                value: [
                  ...widgets.filter((i) => i.uuid !== props.item.uuid),
                  values,
                ],
                key,
              },
              () => {
                handleSuccessMessages("ویرایش اطلاعات انجام شد");
                props.close();
              }
            )
          );
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty, values }) => (
          <Form>
            <div className="box rounded p-3">
              <h3>تنظیمات ویجت ها</h3>
              <hr className="my-2" />
              <div className="">
                <div className="intro-x grid grid-cols-2 gap-4">
                  <Field
                    placeholder="انتخاب نوع"
                    label="انتخاب نوع :"
                    name="type"
                    component={Select}
                    options={[
                      { value: "PRODUCT_LIST", label: "محصولات" },
                      { value: "FEATURED_LIST", label: "محصولات ویژه" },
                      { value: "NEW_PRODUCT_LIST", label: "محصولات جدید" },
                      { value: "GENRE_LIST", label: "ژانرها" },
                      { value: "PRODUCT", label: "تک محصول" },
                    ]}
                  />
                  {values.type == "PRODUCT" && (
                    <Field
                      placeholder="شناسه محصول"
                      label="شناسه محصول :"
                      name="product_id"
                      type="number"
                      component={TextField}
                      validate={(value) => validationWrapper(value, number)}
                    />
                  )}
                  {(values.type == "NEW_PRODUCT_LIST" ||
                    values.type == "FEATURED_LIST") && (
                    <Field
                      placeholder="تعداد محصول"
                      label="تعداد محصول :"
                      name="count"
                      component={TextField}
                    />
                  )}
                  <Field
                    placeholder="عنوان"
                    label="عنوان :"
                    name="title"
                    component={TextField}
                  />
                  <Field
                    placeholder="عنوان انگلیسی"
                    label="عنوان انگلیسی :"
                    name="en_title"
                    component={TextField}
                  />
                  <Field
                    label="خلاصه"
                    name="description"
                    component={TextArea}
                  />
                  <Field
                    label="خلاصه انگلیسی"
                    name="en_description"
                    component={TextArea}
                  />

                  <Field
                    label="کلمات کلیدی:"
                    name="keywords"
                    valueOnly
                    component={MultiselectAddNew}
                  />

                  <Field
                    label="کلمات کلیدی انگلیسی:"
                    name="en_keywords"
                    valueOnly
                    component={MultiselectAddNew}
                  />

                  <Field
                    placeholder="اولویت"
                    label="اولویت :"
                    name="order"
                    component={TextField}
                    type="number"
                  />
                  <Field
                    placeholder="فعال"
                    label="فعال "
                    name="status"
                    component={CheckBox}
                  />
                  <Field
                    placeholder="نمایش تصادفی"
                    label="نمایش تصادفی "
                    name="random_sort"
                    component={CheckBox}
                  />
                  {values.type == "PRODUCT_LIST" && (
                    <>
                      <div>
                        <Field
                          placeholder="انتخاب دسته بندی"
                          label="انتخاب دسته بندی :"
                          name="categories"
                          component={MultiSelect}
                          valueOnly={true}
                          options={core.productCategories || {}}
                        />
                      </div>
                      <div>
                        <Field
                          placeholder="انتخاب ژانر"
                          label="انتخاب ژانر :"
                          name="genres"
                          component={MultiSelect}
                          valueOnly={true}
                          options={core.genres || {}}
                        />
                      </div>
                    </>
                  )}

                  <button
                    className="mt-4 btn btn-primary w-20"
                    type="submit"
                    disabled={!!(isSubmitting || !dirty)}
                  >
                    {isSubmitting ? <Loading /> : "ذخیره"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function DeleteWidget(props) {
  const { dispatch, getSetting, submitSetting, widgets } = useSetting();
  const core = useCore();
  const key = "widgets";
  useEffect(() => {
    dispatch(getSetting(key));
    core.dispatch(core.getProductCategories());
    core.dispatch(core.getGenres());
  }, []);
  return (
    <Modal show={props.show} handleClose={props.close} title={props.title}>
      <div className="modal-body gap-y-3">
        <h4>آیا از حذف این ویجت مطمئن هستید؟</h4>
      </div>
      <div className="modal-footer flex justify-between">
        <button
          className="btn btn-danger w-20"
          type="button"
          onClick={props.submite}
        >
          حذف
        </button>
        <button
          type="button"
          onClick={props.close}
          className="btn btn-outline-secondary w-20 mr-1"
        >
          انصراف
        </button>
      </div>
    </Modal>
  );
}
